/**
 * product
 */

import Vue from 'vue/dist/vue.common';
import { mapGetters } from 'vuex';
import Component from '../../js/lib/component';

import store, { eventBus, priceFormat } from '../../js/Store';
import counter from '../counter/counter.vue';

const classList = {
    root: '.js-product'
};

export default class Product extends Component {
    init() {
        const id = Number(this.$.root.data('id'));
        const productInCart = store.getters.product(id);
        const amount = productInCart
            ? productInCart.amount
            : Number(this.$.root.data('amount')) || 1;
        const cost = Number(this.$.root.data('cost')) || 0;
        const max = Number(this.$.root.data('max')) || Infinity;
        const _this = this;

        new Vue({
            name: 'Product',
            el: this.$.root.get(0),
            data: {
                id,
                amount,
                max,
                inCart: false,
                isReady: false,
                isLoading: false
            },
            computed: {
                cost() {
                    return priceFormat(cost * this.amount);
                }
            },
            store,
            components: {
                counter
            },
            methods: {
                init() {
                    if (this.$el.dataset.fromLoadMore === '1') {
                        console.log('lllll')
                        this.inCart = false;
                        this.isReady = true;

                        if (
                            _this.state.subscribers &&
                            _this.state.subscribers.init.length
                        ) {
                            _this.state.subscribers.init.forEach((fn) => fn());
                        }

                        return;
                    }

                    store.dispatch('getProduct', this.id).then(([product]) => {
                        if (product) {
                            this.inCart = true;
                        }

                        this.isReady = true;

                        if (
                            _this.state.subscribers &&
                            _this.state.subscribers.init.length
                        ) {
                            _this.state.subscribers.init.forEach((fn) => fn());
                        }
                    });
                },
                addToCart() {
                    this.isLoading = true;

                    if (id) {
                        store
                            .dispatch('addProduct', {
                                id: this.id,
                                amount: this.amount
                            })
                            .done(() => {
                                this.inCart = true;
                            })
                            .fail((err) => {
                                console.error(err);
                            })
                            .always(() => {
                                this.isLoading = false;
                            });
                    }
                },
                updateAmount({ amount }) {
                    this.isLoading = true;
                    this.amount = amount;

                    store
                        .dispatch('updateProductAmount', {
                            id: this.id,
                            amount
                        })
                        .then(() => {
                            this.isLoading = false;
                        });
                }
            },
            mounted() {
                setTimeout(() => this.init(), 0);

                eventBus.$on('product.remove', ({ id }) => {
                    if (id === this.id) {
                        this.inCart = false;
                    }
                });

                eventBus.$on('product.add', ({ id }) => {
                    if (id === this.id) {
                        this.inCart = true;
                    }
                });
            }
        });
    }
    onInit(fn) {
        this.state.subscribers && this.state.subscribers.init.push(fn);
    }
    static mount() {
        return Component.mount(Product, {
            name: 'Product',
            classList,
            state: {
                subscribers: {
                    init: []
                }
            }
        });
    }
    static mountOne($node) {
        const instance = new Product($node.get(0), {
            name: 'Product',
            classList,
            state: {}
        });

        return instance;
    }
    static get classList() {
        return classList;
    }
}

Product.mount();
